'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import TabContext from '@classify/react-core-components/TabContext';
import PoliciesSection from './PoliciesSection';
import PoliciesTabBar from './PoliciesTabBar';
import PolicyContent from './PolicyContent/PolicyContent';
import type { Policy, PolicySummary } from '../../types';
type PoliciesScreenProps = {
  currentPolicy: Policy;
  getPolicyHref?: (policy: PolicySummary) => string;
  onPolicyChange?: (policy: PolicySummary) => void;
  shouldPreventPolicyNavigation?: boolean;
  policies: PolicySummary[];
};
export default function PoliciesScreen(t0) {
  const $ = _c(22);
  const {
    currentPolicy,
    getPolicyHref,
    onPolicyChange,
    shouldPreventPolicyNavigation: t1,
    policies
  } = t0;
  const shouldPreventPolicyNavigation = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== currentPolicy || $[1] !== policies) {
    let t3;
    if ($[3] !== currentPolicy) {
      t3 = policy => policy.type === currentPolicy.type;
      $[3] = currentPolicy;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = policies.findIndex(t3);
    $[0] = currentPolicy;
    $[1] = policies;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const currentIndexType = t2;
  const [tabId, setTabId] = useState(String(currentIndexType));
  let t3;
  if ($[5] !== onPolicyChange || $[6] !== policies) {
    t3 = (_, newId) => {
      setTabId(newId);
      const policy_0 = policies[Number(newId)];
      if (policy_0) {
        onPolicyChange?.(policy_0);
      }
    };
    $[5] = onPolicyChange;
    $[6] = policies;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handlePolicyChange = t3;
  let t4;
  if ($[8] !== shouldPreventPolicyNavigation) {
    t4 = event => {
      if (shouldPreventPolicyNavigation) {
        event.preventDefault();
      }
    };
    $[8] = shouldPreventPolicyNavigation;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handlePolicyClick = t4;
  let t5;
  if ($[10] !== getPolicyHref || $[11] !== handlePolicyChange || $[12] !== handlePolicyClick || $[13] !== policies) {
    t5 = <PoliciesSection><PoliciesTabBar getPolicyHref={getPolicyHref} policies={policies} onChange={handlePolicyChange} onPolicyClick={handlePolicyClick} /></PoliciesSection>;
    $[10] = getPolicyHref;
    $[11] = handlePolicyChange;
    $[12] = handlePolicyClick;
    $[13] = policies;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== currentPolicy || $[16] !== tabId) {
    t6 = <PoliciesSection><PolicyContent policy={currentPolicy} index={tabId} /></PoliciesSection>;
    $[15] = currentPolicy;
    $[16] = tabId;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== tabId) {
    t7 = <TabContext value={tabId}>{t5}{t6}</TabContext>;
    $[18] = t5;
    $[19] = t6;
    $[20] = tabId;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}